// Widget base: matriz Departamento × Retailer (réplica de "Price Index - Última Fecha").
// Pinta cada celda con un fondo de color según el signo/intensidad del índice
// (heatmap), igual que el condicional de PowerBI.
import React from 'react';
import { formatValue } from '../format';

function cellBg(value, theme) {
  if (value === null || value === undefined) return 'transparent';
  const v = Number(value);
  // Intensidad proporcional, saturando a ±50%.
  const intensity = Math.min(Math.abs(v) / 50, 1) * 0.45 + 0.10;
  // Negativo (barato) = teal, positivo (caro) = rojo. Mismo criterio que los KPIs.
  return v < 0
    ? `rgba(43, 182, 163, ${intensity})`
    : `rgba(232, 97, 94, ${intensity})`;
}

export default function MatrixTable({ block, data, theme }) {
  const matrix = data?.[block.source];
  const departments = matrix?.departments || [];
  const retailers = matrix?.retailers || [];
  const cells = matrix?.cells || {};

  return (
    <div className="vz-card">
      <div className="vz-card-title" style={{ background: theme.primary }}>{block.title}</div>
      <div className="vz-matrix-scroll">
        <table className="vz-matrix">
          <thead>
            <tr>
              <th className="vz-matrix-rowhead">{block.rowLabel || ''}</th>
              {retailers.map((r) => <th key={r}>{r}</th>)}
            </tr>
          </thead>
          <tbody>
            {departments.map((dep) => (
              <tr key={dep}>
                <td className="vz-matrix-rowhead">{dep}</td>
                {retailers.map((r) => {
                  const v = cells[dep]?.[r];
                  return (
                    <td key={r} style={{ background: block.colorScale ? cellBg(v, theme) : 'transparent' }}>
                      {v === null || v === undefined ? '' : formatValue(v, block.format)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        {departments.length === 0 && <div className="vz-empty">Sin datos para los filtros seleccionados</div>}
      </div>
    </div>
  );
}
